// Components
import Card from "../../Card";
import { Button } from "../../../button/Button";
import { Locale, getLocalization } from "../../../../helpers/localization";
// CSS
import "./dependents/css/menu-category-card.scss";

interface CardProps {
  title: string;
  description: string;
  image: string;
  deviceLanguage: Locale;
}

const MenuCategoryCard: React.FC<CardProps> = ({
  title,
  description,
  image,
  deviceLanguage,
}) => {
  return (
    <Card additionalClassNames={`menu-category-card padding-bottom-40`}>
      <div></div>
      <h2 className="card-title padding-top-20 padding-bottom-20">{title}</h2>
      <p className="card-description padding-bottom-40">{description}</p>

      <div className="button-container">
        <Button
          variant="neutral"
          buttonSize="medium"
          text={getLocalization("shared", "viewMenu", deviceLanguage)}
          additionalClassNames="full-flex"
          url="/menu"
        />
      </div>

      <img src={image} alt={title} className="menu-category-card-image" />
      <div className="card-overlay dark-image-overlay-500"></div>
    </Card>
  );
};

export default MenuCategoryCard;
